import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export enum DurationUnit {
  month = 'month',
  year = 'year',
}

export const CTA_PLAN_LIST_SCHEMA = Object.freeze({
  TITLE: '',
  SUBTITLE: '',
  HIGHLIGHT: '',
  PAGE_TITLE: '',
  URI: '',
  DURATION: 0,
  DURATION_UNIT: DurationUnit.month,
  PLAN_UUID: '',
});
const RECORD = generateSchema(CTA_PLAN_LIST_SCHEMA);
const KEYS: any = generateKeys(CTA_PLAN_LIST_SCHEMA);

export class CtaPlan extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get subtitle(): string {
    return this.get(KEYS.SUBTITLE);
  }

  get highlight(): string {
    return this.get(KEYS.HIGHLIGHT);
  }

  get pageTitle(): string {
    return this.get(KEYS.PAGE_TITLE);
  }

  get uri(): string {
    return this.get(KEYS.URI);
  }

  get planUuid(): string {
    return this.get(KEYS.PLAN_UUID);
  }

  get duration(): number {
    return this.get(KEYS.DURATION);
  }

  get durationUnit(): DurationUnit {
    return this.get(KEYS.DURATION_UNIT);
  }
}
